import React, { useEffect, useState, useRef } from 'react';
import {
    Typography, Paper, Grid, DialogTitle, DialogContent, DialogActions,
    IconButton,
    InputAdornment,
    Button,
    Dialog,
    Box
} from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import CloseIcon from '@material-ui/icons/Close';
import { addUserMultiUser,editUserMultiUser } from '../../../store/actions/userActionCreators';
import * as logger from "../../../logger";
import { sendError, sendSucces } from "../../../utils/utils";
import { trackDwebEvent } from '../../analytics';


const useStyles = makeStyles(theme => ({

    brV1: {
        borderRadius: 16
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingRight: 18,
        paddingTop: 16,
        paddingBottom: 16,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 600
    },
    dialogContentV1: {
        paddingTop: 16,
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    textV1: {
        marginTop: 6,
        "& .MuiInputBase-input": {
            paddingTop: '8.5px',
            paddingBottom: '8.5px'
        },
        "& .MuiOutlinedInput-input": {
            textTransform: 'capitalize',
        },
    },
    dialogActionsV1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    mrV1: {
        marginRight: 16
    },
    closeIcon: {
        fontSize: 18
    },
    mtV1: {
        marginTop: 16
    },
    checkV1: {
        '& .MuiFormControlLabel-label': {
            fontSize: 14,
        },
        '& .MuiButtonBase-root':{
            padding:"0px 9px"
        },
        '& .MuiCheckbox-colorSecondary.Mui-checked': {
            color: '#6200ee !important',
        },
        '& .MuiCheckbox-colorSecondary.Mui-disabled': {
            color: '#6200ee !important',
            opacity:0.5
        }
    },
    checkList:{
        
    },
    checkRoot: {
        color: '#6200ee',
    },
    note:{
        color:'#0033CC',
        fontWeight:600,
        marginRight:8,
        width:55,
        fontSize:14
    },
    desc:{
        fontSize:14
    },
    noteBox:{
        padding: '8px 7px 8px 12px',
        borderRadius: 4,
        backgroundColor: '#edf1fa',
        fontSize:14,
        marginTop:8
    },
    selectedLabel:{
        fontWeight:600
    }
}));

const MuiltiUserAddUserDialog = ({ open,edit,editData, onClose, onSave, dispatchAddUserMultiUser,dispatchEditUserMultiUser }) => {
    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [userName, setUserName] = useState("");
    const [mobileNumber, setMobileNumber] = useState('');
    const [permission, setPermission] = useState(['read']);

    const classes = useStyles();

    const initialValues = {
        name: userName,
        mobile: mobileNumber ? (mobileNumber.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : "",
        permission:permission
    }
    useEffect(()=>{
        if(edit && editData){
            let editPerm = ['read']
            if(editData && editData.name){
                setUserName(editData.name)
            }
            if(editData && editData.contact_number){
                setMobileNumber(editData.contact_number)
            }
            if(editData && editData.create){
                editPerm.push('create')
            }
            if(editData && editData.update){
                editPerm.push('update')
            }
            if(editData && editData.delete){
                editPerm.push('delete')
            }
            setPermission(editPerm);
        }
    },[open,edit,editData])
    const handleClose = () => {
        if(edit){
            trackDwebEvent("Dweb User Management Edit Permission backdrop cancelled", {
                invited_user_name: userName,
                invited_user_contact_number: mobileNumber,
                is_khata_edit_permission_given:editData.upadte,
                is_khata_delete_permission_given:editData.delete,
                is_khata_add_permission_given:editData.create,
            })
        }else {
            trackDwebEvent("Dweb Add User cancelled", {
                invited_user_name: userName,
                invited_user_contact_number: mobileNumber
            })
        }
        setDialogOpen(false);
        onClose();
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.title}>User Name</div>
                            <TextField
                                placeholder="Enter Name"
                                name="name"
                                variant="outlined"
                                size="small"
                                //disabled={edit?true:false}
                                className={classes.textV1}
                                onChange={(e) => {
                                    setUserName(e.target.value)
                                }
                                }
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible:edit?false: true,
                field: (
                    <>
                        <div className={classes.mtV1}>
                            <div className={classes.title}>User Mobile Number</div>
                            <TextField
                                placeholder="Enter Mobile Number"
                                name="mobile"
                                variant="outlined"
                                type='text'
                                size="small"
                                onChange={(e) => setMobileNumber(e.target.value)}
                                fieldProps={{parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""}}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>
                                }}
                                inputProps={{
                                    maxlength:11,
                                    minlength:11
                                }}
                                className={classes.textV1}
                            />
                        </div>
                    </>
                )
            }/*,
            {
                size: 12,
                visible: false,
                field: (
                    <>
                        <div>
                            <div className={classes.title}>Select Role</div>
                            <Radios
                                name="userRole"
                                required={true}
                                // formControlProps={{
                                //     margin: 'none',
                                //     className: classes.paymentTypeRadio,
                                //     fullWidth: true
                                // }}
                                formControlLabelProps={{
                                    className: classes.paymentTypeLabel
                                }}
                                className={classes.radioV1}
                                radioGroupProps={{ row: true }}
                                data={[
                                    { value: 'ADMIN', label: 'Admin' },
                                    { value: 'USER', label: 'Other' }
                                ]}
                            />
                        </div>
                    </>
                )
            }*/,
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <div className={classes.mtV1}>
                        <div className={classes.title} style={{marginBottom:8}}>{edit?'Set Access':'Set Khata Permission'}</div>
                        <Checkboxes
                            name="permission"
                            formGroupProps={{ row: true }}
                            data={[
                                { value: 'read', label:'See Entries',disabled:true},
                                { value: 'create', label:<span className={permission.includes('create')?classes.selectedLabel:{}}>Add Entries</span>},
                                { value: 'update', label:<span className={permission.includes('update')?classes.selectedLabel:{}}>Change Entries</span>},
                                { value: 'delete', label:<span className={permission.includes('delete')?classes.selectedLabel:{}}>Delete Entries</span>}
                            ]}
                            onClick={(e,values) => {
                                var array = [...permission]; // make a separate copy of the array
                                var index = array.indexOf(e.target.value)
                                if (index !== -1) {
                                    array.splice(index, 1);
                                    setPermission(array);
                                }else{
                                    setPermission([...array,e.target.value]); 
                                }
                            }}
                            className={classes.checkList}
                            formControlLabelProps={{
                                className: classes.checkV1
                            }}
                        />
                    </div>
                </>
            )
        },
        {
            size: 12,
            visible: true,
            field: (
                <>
                    <Box display={'flex'} className={classes.noteBox}>
                        <Typography className={classes.note}>Note :</Typography>
                        <Typography className={classes.desc}>Khata includes trips, trucks, transactions, parties, suppliers and drivers.</Typography>
                    </Box>
                </>
            )
        }
        ]
    }

    const validate = values => {
        const errors = {}

        let partyName = values.name ? /^(\w+\s?)*\s*$/.test(values.name.trim()) : "";
        let number = values.mobile ? /^[1-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

        if (!partyName) {
            errors.name = "Please enter valid name."
        }

        if (!number) {
            errors.mobile = "Please enter valid 10-digit mobile number."
        }

        return errors;
    }

    const onSubmit = values => {
        let userNameArray = values.name.split(" ");
        let userNameCapitalize = [];

        if (userNameArray && userNameArray.length > 0) {
            userNameArray.forEach((value) => {
                if (value) {
                    userNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }
        const userData = {
            mobileNumber: values.mobile ? values.mobile.replace("-", "") : "",
            name: userNameCapitalize && userNameCapitalize.length > 0 ? (userNameCapitalize.join(" ")).trim() : "",
        }
        let perm = [
            'read',
            'create',
            'update',
            'delete'
        ]
        if(perm && perm.length>0 && values && values.permission){
            perm.forEach(element => {
                let index = values.permission.indexOf(element);
                if (index !== -1) {
                    userData[`${element}`]=true
                }else{
                    userData[`${element}`]=false
                }
            });
        }
        if(edit){
            //delete userData.name;
            dispatchEditUserMultiUser(userData,
                (data) => {
                    if (data && data.status.code && data.status.code === 200) {
                        sendSucces("User Updated successfully");
                        logger.log('MultiUserAddUserDailog Dweb ', 'Dweb User Management Permission edited');
                        setDialogOpen(false);
                        if(onSave){
                          onSave(userData);
                        }
                        trackDwebEvent("Dweb User Management Permission edited", {
                            invited_user_name: data && data.response && data.response.userOrgName ? data.response.userOrgName : "",
                            invited_user_contact_number: data && data.response && data.response.mobileNumber ? data.response.mobileNumber : "",
                            invited_user_id: data && data.response && data.response.userId ? data.response.userId : "",
                            invited_user_status: data && data.response && data.response.userStatus ? data.response.userStatus : ""
                        });
                    }
                },
                (data) => {
                    trackDwebEvent("Dweb User Management Permission  failed", {
                        invited_user_name: userData && userData.name ? userData.name : "",
                        invited_user_contact_number: userData && userData.mobileNumber ? userData.mobileNumber : "",
                        failure_reason: data && data.status && data.status.message ? data.status.message : ""
                    })
                    logger.log('MultiUserAddUserDailog Dweb ', 'User added failed');
                }
            );
        }else{
            dispatchAddUserMultiUser(userData,
                (data) => {
                    if (data && data.status.code && data.status.code === 200) {
                        sendSucces("User added successfully");
                        logger.log('MultiUserAddUserDailog Dweb ', 'User added successfully');
                        setDialogOpen(false);
                        onSave(userData);
                        trackDwebEvent("Dweb Add User successful", {
                            invited_user_name: data && data.response && data.response.userOrgName ? data.response.userOrgName : "",
                            invited_user_contact_number: data && data.response && data.response.mobileNumber ? data.response.mobileNumber : "",
                            invited_user_id: data && data.response && data.response.userId ? data.response.userId : "",
                            invited_user_status: data && data.response && data.response.userStatus ? data.response.userStatus : "",
                            is_khata_edit_permission_given:userData.upadte,
                            is_khata_delete_permission_given:userData.delete,
                            is_khata_add_permission_given:userData.create,
                        });
                    }
                },
                (data) => {
                    trackDwebEvent("Dweb Add User failed", {
                        invited_user_name: userData && userData.name ? userData.name : "",
                        invited_user_contact_number: userData && userData.mobileNumber ? userData.mobileNumber : "",
                        failure_reason: data && data.status && data.status.message ? data.status.message : "",
                        is_khata_edit_permission_given:userData.upadte,
                        is_khata_delete_permission_given:userData.delete,
                        is_khata_add_permission_given:userData.create,
                    })
                    logger.log('MultiUserAddUserDailog Dweb ', 'User added failed');
                }
            );
        }
        

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-user-multi-user-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divTitle} >
                        {edit?'Edit Khata Permissions':'Add User'}
                    </div>
                    <div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContentV1} dividers>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id={`multiuser${edit?'edit':'add'}form`}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate  id={`multiuser${edit?'edit':'add'}form`}>
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <div className={classes.mrV1} >
                        <Button variant="contained" className="modal-close-cta-global" onClick={handleClose}>
                            Close
                        </Button>
                    </div>
                    <div>
                        <Button variant="contained" type="submit" className="modal-save-cta-uam"
                            onClick={event => {
                                submit(event)
                            }}
                        >
                            Confirm
                        </Button>
                    </div>
                </DialogActions>

            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchAddUserMultiUser: (data, onSuccess, onError) => {
        dispatch(addUserMultiUser(data, onSuccess, onError))
    },
    dispatchEditUserMultiUser: (data, onSuccess, onError) => {
        dispatch(editUserMultiUser(data, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(MuiltiUserAddUserDialog);